import React from 'react';
import style from './index.module.css';
import MyFooter from '../../components/MyFooter';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { imageListData } from '../../assets/constants';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import useMediaQuery from '@mui/material/useMediaQuery';

function srcset(image, size, rows = 1, cols = 1) {
	return {
		src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
		srcSet: `${image}?w=${size * cols}&h=${
			size * rows
		}&fit=crop&auto=format&dpr=2 2x`,
	};
}

const Gallery = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const isTablet = useMediaQuery(theme.breakpoints.down('md'));

	const cols = isMobile ? 1 : isTablet ? 2 : 4;

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			style={{
				width: '100%',
				minHeight: '100vh',
				backgroundColor: theme.palette.background.default,
				color: theme.palette.text.primary,
			}}
		>
			<div className={style.container}>
				<motion.div 
					initial={{ y: -20, opacity: 0 }}
					animate={{ y: 0, opacity: 1 }}
					className={style.header}
				>
					<p style={{ color: theme.palette.primary.main }}>OUR WORK</p>
					<h1>A Glimpse of Celebrations</h1>
				</motion.div>

				<motion.div 
					initial="initial"
					animate="animate"
					variants={{
						animate: {
							transition: {
								staggerChildren: 0.05
							}
						}
					}}
					className={style.imageListStyle}
				>
					<ImageList variant='quilted' cols={cols} rowHeight={300} gap={16}>
						{imageListData.map((item, index) => (
							<ImageListItem
								key={index}
								cols={isMobile ? 1 : (item.cols || 1)}
								rows={isMobile ? 1 : (item.rows || 1)}
								component={motion.div}
								variants={{
									initial: { opacity: 0, scale: 0.8 },
									animate: { opacity: 1, scale: 1 }
								}}
								whileHover={{ scale: 1.02, zIndex: 1 }}
							>
								<img
									{...srcset(item.img, 300, item.rows, item.cols)}
									alt={item.title}
									loading='lazy'
									style={{ borderRadius: '1rem', cursor: 'pointer' }}
								/>
							</ImageListItem>
						))}
					</ImageList>
				</motion.div>
			</div>

			{/* Footer Section */}
			<MyFooter />
		</motion.div>
	);
};

export default Gallery;
